import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import { ProfileActionTypes, ProfileState } from './types'

export const profileInitialState: ProfileState = {
  profile: {
    firstName: '',
    lastName: '',
    dob: '',
    createdAt: '',
    email: '',
    id: 0,
    gender: ''
  }
}

export const profileReducer: Reducer<ProfileState> = createReducer<
  ProfileState
>(profileInitialState, {
  [ProfileActionTypes.PUT_PROFILE_REQUEST]: (state: ProfileState) => ({
    ...state
  }),
  [ProfileActionTypes.PUT_PROFILE_SUCCESS]: (state: ProfileState, action) => ({
    ...state
  }),
  [ProfileActionTypes.PUT_PROFILE_FAIL]: (state: ProfileState) => ({
    ...state
  }),

  [ProfileActionTypes.GET_PROFILE_REQUEST]: (state: ProfileState) => ({
    ...state
  }),
  [ProfileActionTypes.GET_PROFILE_SUCCESS]: (state: ProfileState, action) => {
    let dob = action.payload.profile.dob
    if (dob) {
      const oldDate = dob.split('-')
      const [y, m, d] = oldDate
      const newDate = [ m, d, y]
      dob = newDate.join('/')
    }
    const PF = {
      profile: {
        ...action.payload.profile,
        dob
      }
    }
    return {
      ...state,
      ...PF // ,
      // dob
    }
  },
  [ProfileActionTypes.GET_PROFILE_FAIL]: (state: ProfileState) => ({
    ...state,
    profile: {
      firstName: '',
      lastName: '',
      dob: '',
      createdAt: '',
      email: '',
      id: 0,
      gender: ''
    }
  })
})
